




























  import {Action, Getter, Mutation, State} from "vuex-class";
import {Vue, Component} from 'vue-property-decorator';
import AdminPageInfo from './AdminPageInfo.vue';
import Axios from "axios";
import alzuhudLink, {toBase64} from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo
    }
})
export default class UserNewTicket extends Vue {
    // @ts-ignore
    @State adminUser: string;
    // @ts-ignore
    @State routes: string[];
    @Getter token: string;
    panelTitle: string = 'New Ticket';
    // @ts-ignore
    @Mutation replaceRoute;
    // @ts-ignore
    @Action snackIt: ({color: string, message: string, snackbar: boolean}) => void;
    subject: string | undefined = undefined;
    file: File | undefined = undefined;
    message: string | undefined = undefined;

    required (value: any): any {

      if (typeof value === typeof []) {
        if (value.length === 0) {
          return 'Required';
        }
        return true;
      }
      return !!value || 'Required';
    }

    ticketData = {
        subject: 'Packages',
        status: 'Answered',
        user: {
            name: 'Arnold Lang',
            userTicketText: 'Minim nulla occaecat ut esse do id. Veniam excepteur quis aute consectetur. Lorem aliquip reprehenderit voluptate Lorem deserunt pariatur velit cupidatat eiusmod ea. Excepteur voluptate enim proident reprehenderit incididunt consequat ullamco qui aliquip aute eiusmod. Et laboris fugiat commodo et irure do sit. Ipsum proident mollit tempor ullamco nostrud tempor. Labore exercitation occaecat fugiat ut mollit incididunt eu labore duis quis. Adipisicing minim qui nisi esse occaecat mollit magna labore proident tempor. Ea elit occaecat et nostrud sint deserunt incididunt amet dolore excepteur duis ex laboris. Consequat ex aute esse incididunt laboris in. Labore dolor ullamco cupidatat id non. In officia veniam proident do quis do amet ea cillum ut.',
            userTicketTime: '12:35 PM',
            userTicketDate: '22.10.2019'
        },
        responder: {
            name: 'Jasmine Andrews',
            responderTicketText: 'Mollit pariatur ipsum consectetur eu deserunt qui amet voluptate. Tempor proident duis magna qui et quis consequat voluptate qui quis. Dolore sunt aliqua et anim nisi.',
            responderTicketTime: '12:35 PM',
            responderTicketDate: '22.10.2019'
        }
    }
    
    mounted () {
        this.replaceRoute(['Support', 'New Ticket']);
    }

    async submitTicket() {

      if (this.subject !== undefined && this.message !== undefined && this.subject !== '' && this.message !== '') {
        let file = '';
        try {
          if (this.file !== undefined)
            file = await toBase64(this.file);
        } catch (e) {
          file = '';
        }

        try {
          const result = await Axios.post(`http://${alzuhudLink}:8080/api/tickets/add`, {
            token: this.token,
            subject: this.subject,
            ticket_img: file,
            body: this.message,
          });
          this.$router.push('support');
        } catch (e) {
          this.snackIt({
            message: 'Failed to Submit New Ticket',
            color: 'error',
            snackbar: true,
          })
        }
      } else {
        this.snackIt({
          message: 'Fill the Required Fields',
          color: 'error',
          snackbar: true,
        })
      }
    }
}
